/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UpdateLeadDecisionRequestBidirectionalActionDetailsDetails } from './UpdateLeadDecisionRequestBidirectionalActionDetailsDetails';
import {
    UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsFromJSON,
    UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsFromJSONTyped,
    UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsToJSON,
    UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsToJSONTyped,
} from './UpdateLeadDecisionRequestBidirectionalActionDetailsDetails';

/**
 * 
 * @export
 * @interface UpdateLeadDecisionRequestBidirectionalActionDetails
 */
export interface UpdateLeadDecisionRequestBidirectionalActionDetails {
    /**
     * 
     */
    action: UpdateLeadDecisionRequestBidirectionalActionDetailsActionEnum;
    /**
     * 
     */
    details?: UpdateLeadDecisionRequestBidirectionalActionDetailsDetails;
}


/**
 * @export
 */
export const UpdateLeadDecisionRequestBidirectionalActionDetailsActionEnum = {
    Accept: 'Accept',
    Decline: 'Decline',
    RequestInformation: 'RequestInformation',
    ReferralReceived: 'ReferralReceived',
} as const;
export type UpdateLeadDecisionRequestBidirectionalActionDetailsActionEnum = typeof UpdateLeadDecisionRequestBidirectionalActionDetailsActionEnum[keyof typeof UpdateLeadDecisionRequestBidirectionalActionDetailsActionEnum];


/**
 * Check if a given object implements the UpdateLeadDecisionRequestBidirectionalActionDetails interface.
 */
export function instanceOfUpdateLeadDecisionRequestBidirectionalActionDetails(value: object): value is UpdateLeadDecisionRequestBidirectionalActionDetails {
    if (!('action' in value) || value['action'] === undefined) return false;
    return true;
}

export function UpdateLeadDecisionRequestBidirectionalActionDetailsFromJSON(json: any): UpdateLeadDecisionRequestBidirectionalActionDetails {
    return UpdateLeadDecisionRequestBidirectionalActionDetailsFromJSONTyped(json, false);
}

export function UpdateLeadDecisionRequestBidirectionalActionDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLeadDecisionRequestBidirectionalActionDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'action': json['action'],
        'details': json['details'] == null ? undefined : UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsFromJSON(json['details']),
    };
}

export function UpdateLeadDecisionRequestBidirectionalActionDetailsToJSON(json: any): UpdateLeadDecisionRequestBidirectionalActionDetails {
    return UpdateLeadDecisionRequestBidirectionalActionDetailsToJSONTyped(json, false);
}

export function UpdateLeadDecisionRequestBidirectionalActionDetailsToJSONTyped(value?: UpdateLeadDecisionRequestBidirectionalActionDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'action': value['action'],
        'details': UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsToJSON(value['details']),
    };
}

